export function deepCopy(input: Object | Array<any>) {
  // This is actually performant, although it cannot resolve circular references.
  return JSON.parse(JSON.stringify(input))
}
